import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { ENVIRONMENTS, ENV_ORDER, tint } from "@/lib/environments";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const EnvironmentPickerDialog = ({ ws }) => {
  const qc = useQueryClient();
  const [saving, setSaving] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const open = !!ws && !ws.environment && !dismissed;
  const isAdmin = ["owner", "admin"].includes(ws?.my_role);
  if (!open || !isAdmin) return null;

  const choose = async (key) => {
    setSaving(true);
    try {
      await api.put(`/workspaces/${ws.id}`, { environment: key });
      qc.invalidateQueries({ queryKey: ["workspace", ws.id] });
      qc.invalidateQueries({ queryKey: ["home"] });
      qc.invalidateQueries({ queryKey: ["workspaces"] });
      toast.success(`"${ws.name}" es ahora un entorno ${ENVIRONMENTS[key].label}`);
      setDismissed(true);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setDismissed(true); }}>
      <DialogContent className="sm:max-w-md rounded-3xl" data-testid="environment-picker-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">¿Qué tipo de entorno es este Espacio?</DialogTitle>
          <DialogDescription>
            Así agruparemos "{ws.name}" con el resto de tus entornos y le daremos su propia identidad.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 gap-2.5 pt-1">
          {ENV_ORDER.map((key) => {
            const env = ENVIRONMENTS[key];
            return (
              <button
                key={key}
                disabled={saving}
                data-testid={`env-picker-${key}`}
                onClick={() => choose(key)}
                className="flex items-center gap-4 p-4 rounded-2xl text-left transition-transform hover:-translate-y-0.5 disabled:opacity-50"
                style={{ backgroundColor: tint(env.color, 0.16) }}
              >
                <span className="text-3xl" aria-hidden>{env.emoji}</span>
                <span className="min-w-0">
                  <span className="block font-heading font-bold" style={{ color: env.text }}>{env.label}</span>
                  <span className="block text-xs text-muted-foreground">{env.desc}</span>
                </span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};
